export default __webpack_public_path__ + "static/coding-agent-f45f69e66f8a15d6b09d26cca40efe25.png";